// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class FilePdfContainerMetadataBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FilePdfContainerMetadataBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFilePdfContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FilePdfContainerMetadataBuf):FilePdfContainerMetadataBuf {
  return (obj || new FilePdfContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFilePdfContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FilePdfContainerMetadataBuf):FilePdfContainerMetadataBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FilePdfContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

format():string|null
format(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
format(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

encryption():string|null
encryption(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
encryption(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

author():string|null
author(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
author(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

title():string|null
title(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
title(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

producer():string|null
producer(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
producer(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

creator():string|null
creator(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
creator(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

subject():string|null
subject(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
subject(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

keywords():string|null
keywords(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
keywords(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startFilePdfContainerMetadataBuf(builder:flatbuffers.Builder) {
  builder.startObject(8);
}

static addFormat(builder:flatbuffers.Builder, formatOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, formatOffset, 0);
}

static addEncryption(builder:flatbuffers.Builder, encryptionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, encryptionOffset, 0);
}

static addAuthor(builder:flatbuffers.Builder, authorOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, authorOffset, 0);
}

static addTitle(builder:flatbuffers.Builder, titleOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, titleOffset, 0);
}

static addProducer(builder:flatbuffers.Builder, producerOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, producerOffset, 0);
}

static addCreator(builder:flatbuffers.Builder, creatorOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, creatorOffset, 0);
}

static addSubject(builder:flatbuffers.Builder, subjectOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, subjectOffset, 0);
}

static addKeywords(builder:flatbuffers.Builder, keywordsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, keywordsOffset, 0);
}

static endFilePdfContainerMetadataBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createFilePdfContainerMetadataBuf(builder:flatbuffers.Builder, formatOffset:flatbuffers.Offset, encryptionOffset:flatbuffers.Offset, authorOffset:flatbuffers.Offset, titleOffset:flatbuffers.Offset, producerOffset:flatbuffers.Offset, creatorOffset:flatbuffers.Offset, subjectOffset:flatbuffers.Offset, keywordsOffset:flatbuffers.Offset):flatbuffers.Offset {
  FilePdfContainerMetadataBuf.startFilePdfContainerMetadataBuf(builder);
  FilePdfContainerMetadataBuf.addFormat(builder, formatOffset);
  FilePdfContainerMetadataBuf.addEncryption(builder, encryptionOffset);
  FilePdfContainerMetadataBuf.addAuthor(builder, authorOffset);
  FilePdfContainerMetadataBuf.addTitle(builder, titleOffset);
  FilePdfContainerMetadataBuf.addProducer(builder, producerOffset);
  FilePdfContainerMetadataBuf.addCreator(builder, creatorOffset);
  FilePdfContainerMetadataBuf.addSubject(builder, subjectOffset);
  FilePdfContainerMetadataBuf.addKeywords(builder, keywordsOffset);
  return FilePdfContainerMetadataBuf.endFilePdfContainerMetadataBuf(builder);
}
}
